<template>
  <div>
    <div class="card p-4 shadow-sm">
      <h3 class="mb-3">Categorías de Platillos</h3>

      <!-- Botón agregar -->
      <div class="d-flex justify-content-end mb-3">
        <button class="btn btn-success" @click="abrirModalCrear">
          + Agregar Categoría
        </button>
      </div>

      <!-- Toast -->
      <div
        v-if="mostrarToast"
        class="toast-container position-fixed top-0 end-0 p-3"
        style="z-index: 1055"
      >
        <div class="toast show align-items-center text-white" :class="toastColor">
          <div class="d-flex">
            <div class="toast-body">
              <i :class="iconoToast" class="me-2"></i>
              {{ alerta.mensaje }}
            </div>
            <button
              type="button"
              class="btn-close btn-close-white me-2 m-auto"
              @click="cerrarToast"
            ></button>
          </div>
        </div>
      </div>

      <!-- Tabla -->
      <div class="table-responsive">
        <table class="table table-bordered text-center align-middle">
          <thead class="table-light">
            <tr>
              <th>Categoría</th>
              <th>Visible en menú público</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="categorias.length === 0">
              <td colspan="3">No hay categorías registradas.</td>
            </tr>
            <tr v-for="cat in categorias" :key="cat.IdCategoria">
              <td>{{ cat.Categoria }}</td>
              <td>
                <span
                  :class="{
                    'badge bg-success': !!cat.Publica,
                    'badge bg-secondary': !cat.Publica,
                  }"
                >
                  {{ cat.Publica ? "Visible" : "Oculta" }}
                </span>
              </td>
              <td>
                <button
                  class="btn btn-primary btn-sm me-2"
                  @click="abrirModalEditar(cat)"
                >
                  Editar
                </button>
                <button
                  class="btn btn-danger btn-sm"
                  @click="abrirModalEliminar(cat)"
                >
                  Eliminar
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Modal Crear -->
    <div v-if="mostrarModalCrear" class="modal-backdrop">
      <div class="modal-content">
        <h5>Nueva Categoría</h5>
        <input
          v-model="nuevaCategoria.Categoria"
          type="text"
          class="form-control mt-3"
          placeholder="Nombre de la categoría"
        />
        <div class="form-check mt-3">
          <input
            v-model="nuevaCategoria.Publica"
            class="form-check-input"
            type="checkbox"
            id="nuevaCategoriaPublica"
          />
          <label class="form-check-label" for="nuevaCategoriaPublica">
            Visible en menú público (QR)
          </label>
        </div>
        <div class="text-end mt-3">
          <button class="btn btn-secondary me-2" @click="cerrarModalCrear">
            Cancelar
          </button>
          <button class="btn btn-primary" @click="guardarCategoria">
            Guardar
          </button>
        </div>
      </div>
    </div>

    <!-- Modal Editar -->
    <div v-if="mostrarModalEditar" class="modal-backdrop">
      <div class="modal-content">
        <h5>Editar Categoría</h5>
        <input
          v-model="categoriaEditar.Categoria"
          type="text"
          class="form-control mt-3"
          placeholder="Nombre de la categoría"
        />
        <div class="form-check mt-3">
          <input
            v-model="categoriaEditar.Publica"
            class="form-check-input"
            type="checkbox"
            id="categoriaEditarPublica"
          />
          <label class="form-check-label" for="categoriaEditarPublica">
            Visible en menú público (QR)
          </label>
        </div>
        <div class="text-end mt-3">
          <button class="btn btn-secondary me-2" @click="cerrarModalEditar">
            Cancelar
          </button>
          <button class="btn btn-primary" @click="actualizarCategoria">
            Guardar
          </button>
        </div>
      </div>
    </div>

    <!-- Modal Eliminar -->
    <div v-if="mostrarModalEliminar" class="modal-backdrop">
      <div class="modal-content">
        <h5>Confirmar eliminación</h5>
        <p>
          ¿Seguro que deseas eliminar la categoría
          <strong>{{ categoriaEliminar?.Categoria }}</strong>?
        </p>
        <div class="text-end mt-3">
          <button class="btn btn-secondary me-2" @click="cerrarModalEliminar">
            Cancelar
          </button>
          <button class="btn btn-danger" @click="eliminarCategoria">
            Eliminar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "@/config/config.js";

export default {
  name: "CategoriasRestaurante",
  data() {
    return {
      categorias: [],
      mostrarModalCrear: false,
      mostrarModalEditar: false,
      mostrarModalEliminar: false,
      nuevaCategoria: { Categoria: "", Publica: true },
      categoriaEditar: null,
      categoriaEliminar: null,
      mostrarToast: false,
      alerta: { mensaje: "", tipo: "success" },
    };
  },
  computed: {
    toastColor() {
      return this.alerta.tipo === "success" ? "bg-success" : "bg-danger";
    },
    iconoToast() {
      return this.alerta.tipo === "success"
        ? "bi bi-check-circle"
        : "bi bi-exclamation-circle";
    },
  },
  methods: {
    cerrarToast() {
      this.mostrarToast = false;
    },
    mostrarAlerta(mensaje, tipo = "success") {
      this.alerta = { mensaje, tipo };
      this.mostrarToast = true;
      setTimeout(this.cerrarToast, 3000);
    },
    async obtenerCategorias() {
      const { data } = await axios.get(`${API_URL}/categorias-comida`);
      this.categorias = data;
    },
    abrirModalCrear() {
      this.nuevaCategoria = { Categoria: "", Publica: true };
      this.mostrarModalCrear = true;
    },
    cerrarModalCrear() {
      this.mostrarModalCrear = false;
    },
    async guardarCategoria() {
      try {
        await axios.post(`${API_URL}/categorias-comida`, this.nuevaCategoria);
        this.mostrarAlerta("Categoría creada correctamente");
        this.cerrarModalCrear();
        this.obtenerCategorias();
      } catch (error) {
        this.mostrarAlerta(
          error.response?.data?.message || "Error al crear",
          "danger"
        );
      }
    },
    abrirModalEditar(categoria) {
      this.categoriaEditar = { ...categoria, Publica: !!categoria.Publica };
      this.mostrarModalEditar = true;
    },
    cerrarModalEditar() {
      this.categoriaEditar = null;
      this.mostrarModalEditar = false;
    },
    async actualizarCategoria() {
      try {
        await axios.put(
          `${API_URL}/categorias-comida/${this.categoriaEditar.IdCategoria}`,
          this.categoriaEditar
        );
        this.mostrarAlerta("Categoría actualizada correctamente");
        this.cerrarModalEditar();
        this.obtenerCategorias();
      } catch (error) {
        this.mostrarAlerta(
          error.response?.data?.message || "Error al actualizar",
          "danger"
        );
      }
    },
    abrirModalEliminar(categoria) {
      this.categoriaEliminar = categoria;
      this.mostrarModalEliminar = true;
    },
    cerrarModalEliminar() {
      this.categoriaEliminar = null;
      this.mostrarModalEliminar = false;
    },
    async eliminarCategoria() {
      try {
        await axios.delete(
          `${API_URL}/categorias-comida/${this.categoriaEliminar.IdCategoria}`
        );
        this.mostrarAlerta("Categoría eliminada correctamente");
        this.obtenerCategorias();
      } catch (error) {
        this.mostrarAlerta(
          error.response?.data?.message || "Error al eliminar",
          "danger"
        );
      } finally {
        this.cerrarModalEliminar();
      }
    },
  },
  mounted() {
    this.obtenerCategorias();
  },
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5000;
}
.modal-content {
  background: #fff;
  width: 400px;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  z-index: 5001;
}
</style>
